import React, { Fragment, useEffect, useState } from 'react'
import './Wishlist.css';
import { useDispatch, useSelector } from 'react-redux';
// import { useParams } from 'react-router-dom';
import { getWishlistItems, removeWishlistItem } from '../../../redux/actions/wishlistAction';
import WishlistCard from './WishlistCard';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isLoggedIn } from '../../../authUtils';
import FavoriteBorderRounded from '@mui/icons-material/FavoriteBorderRounded';


function Wishlist(props) {
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector((state) => state.user);
  const {wishlist, loading} = useSelector((state) => state.wishlist);

  useEffect(() => {
      dispatch(getWishlistItems());
  }, [dispatch]);

  const wslstToast = () => {
    toast.info('Item removed from Wishlist', {
      position: "top-center",
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      });
  }

  const onRemoveWishlistItem = (_id) => {
      if(isLoggedIn) {
          dispatch(removeWishlistItem({ wishlistId: _id }));
        }
      wslstToast(toast.info);
  }

  return (
    <Fragment>
      <div className='wl_main'>
        {wishlist ? 
        <div className='wishlist_cards'>
        {wishlist && wishlist.map(wishlst => (
          <WishlistCard key={wishlst._id} wishlst={wishlst} onRemoveWishlistItem={onRemoveWishlistItem}/>
        ))}
      </div> : 
      <div className='empty_wishlist'>
        <span><FavoriteBorderRounded className='wishlist_heart_icon' style={{fontSize: '3.2rem'}}/></span>
        <div>You haven't saved anything</div>
        <button>Start shopping</button>
      </div>}
      </div>
    </Fragment>
  )
}

export default Wishlist;